import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';

import {
    exibirDocumento, addState
} from '../../actions'
import Historico from '../../components/Historico';
import Signatarios from '../../components/Signatarios';
import { detectar_mobile } from '../../utils';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class Documento extends Component {
    constructor(){
        super()
        this.state = {
            numPages: null,
            pageNumber: 1,
            fileURL: undefined,
            showHistorico: !detectar_mobile()
        }
    }

    async componentWillMount(){
        const historico = await localStorage.getItem('historico')
        this.props.addState({ historico: JSON.parse(historico) })
    }

    async componentDidMount(){
        if(!localStorage.getItem('user')) {
            this.props.history.push('/');
        }

        const documento = await localStorage.getItem('documento');
        const file = documento.replace(/"/g, '')
        this.setState({fileURL: file})
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    showHist = () => this.setState({ showHistorico: !this.state.showHistorico })

    render() {
        var { exibir_doc, exibir_doc_load, historico } = this.props.documentos
        const { pageNumber, numPages, fileURL, showHistorico } = this.state;
        const widthPDF = showHistorico ? detectar_mobile() ? '40%':'70%' : '100%'
        const widthHistorico = detectar_mobile() ? '60%' : '30%'
 
        const infosDoc = historico ? historico.infosDoc : { titulo:'', numero:'', protocolo:'' }

        const { titulo, numero, protocolo } =  infosDoc
        return (
            <div style={customStyles.container}>
                <div className="modal-header" style={customStyles.header}>
                    <div onClick={this.showHist} className="modal-title" id="exampleModalLabel" style={{...customStyles.text, display: 'flex',alignItems:'center', cursor:'pointer'}}>
                        <img src='/assets/imagem/menu.png' style={{ width:30, marginRight: 10}}/>
                        <span>Visualizar Documento</span>
                    </div>
                    <button type="button" className="btn btn-primary" onClick={ () => this.props.history.push('/assinatura')}>
                        <div className="modal-title" style={customStyles.text}>Assinar</div>
                    </button>
                </div>

                <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-between', minHeight:'100%' }}>
                    
                    {historico != undefined && showHistorico && <div style={{  padding: detectar_mobile() ? '3%' :'1.1%',height: '100%', width: widthHistorico, backgroundColor:'white'}}>
                        
                        <div style={{ height:70, marginBottom: 10, borderBottom:'1px solid #dee2e6', paddingBottom: 8}}>
                            <img src='/assets/imagem/logo-fondo-claro.png' style={{ height:'100%', width:'100%', objectFit:'contain'}} />
                        </div>
                        
                        <div>
                            <strong style={{ display:'flex', alignItems:'center'}}>
                                <img src='/assets/imagem/document.png' style={{ width: 25, marginRight: 5 }} />
                                <span className="" style={{ wordBreak:'break-word', fontSize: 22 }}>{titulo}</span>
                                {numero && <span style={{ fontSize: 13 }} className={``}> - Nº {numero}</span>} 
                            </strong>
                           
                            <p className="h7" style={{ fontSize: 12, color:'gray', wordBreak:'break-word'}}>{protocolo}</p>
                        </div>

                        <div style={{display:'flex', alignItems:'center'}}>
                            <img src="/assets/imagem/icon-contrato.png" style={{ width: 30}} />
                            <span style={{ fontSize: 13, marginLeft: 5}}>Para melhor visualização, faça download do contrato <a href={`data:application/pdf;base64,${fileURL}`} download={titulo}>clicando aqui!</a></span>
                        </div>

                        <Signatarios />

                        <Historico />
                    </div>}
                    
                    <div style={{ width: widthPDF, /*height:'100%'*/ }}>
                        {fileURL != undefined ?
                            <object style={customStyles.framePDF} data={fileURL} type='application/pdf' name="PDF">
                            {/* <object style={customStyles.framePDF} data={`data:application/pdf;base64,${fileURL}`} type='application/pdf' name="PDF">  */}
                                
                                {!showHistorico && <div style={{display:'flex',alignItems:'end'}}>
                                    <img src="/assets/imagem/icon-contrato.png" style={customStyles.img} />
                                    <p style={{padding:'2%'}}>Para melhor visualização, faça download do contrato <a href={`data:application/pdf;base64,${fileURL}`} download={titulo}>clicando aqui!</a></p>
                                </div>}

                                {/* <iframe src={`data:application/pdf;base64,${fileURL}`}></iframe> */}
                                <Document 
                                    id='view-pdf'
                                    file={fileURL}
                                    onLoadSuccess={() => this.onDocumentLoadSuccess}
                                    //onLoadError={(error) => console.log('error',error)}
                                    >
                                    <Page pageNumber={pageNumber}  style={{width:'100%'}} />
                                </Document>
                                
                            </object>
                            :<div className="d-flex justify-content-center">
                                {exibir_doc_load
                                    ?<div className="spinner-border" role="status" style={{margin:'1%'}}>
                                        
                                    </div>
                                    :'Nenhum arquivo PDF encontrado.'
                                }
                            </div>
                        }
                    </div>
                    
                </div>                

                <style>
                    {
                        `
                            .react-pdf__Page__canvas{
                                width:100%!important;
                                height:100%!important;
                                border: 1px solid rgb(52, 58, 64);
                            }
                            .react-pdf__Page__textContent{
                                width:100%!important;
                                height:100%!important;
                            }
                        `
                    }
                </style>
            </div>
        )
    }
}

const mapStateToProps = ({ auth, documentos }) => {
    return {
        auth,
        documentos
    }
}

export default connect(mapStateToProps, {
    exibirDocumento, addState
})(Documento);

const customStyles = {
    framePDF: {
        width:'100%',
        height: '100%',//window.innerHeight - 54,
        marginBottom: -50
    },
    container: {
        width:'100%',
        height:'100%',
    },
    text: {
        fontSize: 'large',
        fontWeight: '500',
        color:'white'
    },
    header: {
        background:'#343a40',
        alignItems:'center',
        color:'white',
        maxHeight: '54px',
        borderRadius:0
    },
    img:{
        width: 60,
        marginLeft:'2.5%'
    }
}